'use strict'

module.exports = {
  relay: '/libp2p/circuit/relay/0.1.0'
}
